// extracted by mini-css-extract-plugin
module.exports = {"header":"PastActionsList_header__1LrOr","lastItem":"PastActionsList_lastItem__3EcUW","lastItemDate":"PastActionsList_lastItemDate__2sQHr","icon":"PastActionsList_icon__2J6gY"};